import script from "./Tooth34.vue?vue&type=script&setup=true&lang=js"
export * from "./Tooth34.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__